<template>
   <div v-if="showState" style="width:calc(100%); height:calc(100%); z-index:1">
    <div 
    id="radarChartContainer" 
    ref="radarChartContainer" 
    style="width:calc(100%); 
    height:calc(100%); 
    z-index:1">
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
   name:'radar',
   props:{
     AssessList:[Object,Array],
     AssessListvalue1:String,
     AssessListvalue2:String,
     AssessListvalue3:String,
   },
   data(){
     return{
      showState:true,
      option: {},
     }
   },
   mounted() {
			if(this.$parent.$el){
				if(this.$parent.$el.clientHeight < 500){
					this.picSize = 'smaPic'
				}else if(this.$parent.$el.clientHeight < 750){
					this.picSize = 'midPic'
				}else if(this.$parent.$el.clientHeight < 1000){
					this.picSize = 'bigPic'
				}
      }
    //   this.getNext()
      window.onresize = () => {
				return (() => {
					// this.getNext()
				})();
      };
    },
    watch:{
        AssessListvalue1(val){
            if(val){
                this.loadData();
                this.getNext();
            } 
        },
        deep:true,
        immediate:true
    },
  methods:{
      loadData(){
           this.option={
        tooltip: {
		    show: true,
		    trigger: 'item', //提示框触发类型，item数据项图形触发，主要应用于无类目轴的图表（散点图、饼形图等）
		    formatter: function(params, ticket, callback) { //第一个参数数据集、第二个参数是异步回调标志、第三个参数是异步回调
		    	return params.seriesName + ": " + params.value ; //系列名称：数据值
		    }
		 },
         title: {
             text: ''
         },
         color: ['red','#FFC63C','#598CFF'],
         legend: {
            //  data: ['高度危险', '较大危险', '一般危险']
             textStyle: {color: '#333'},
             x: '72%',
             top:'17%',
         },
        radar: [
        {
            indicator: [
                { text: '一星'},
                { text: '二星'},
                { text: '三星'},
                { text: '四星'},
                { text: '五星'},
            ],
            center: ['36%', '50%'],
            radius: '70%'
        }
    ],
    series: [
        {
            name: '评分',
            type: 'radar',
            emphasis: {
                lineStyle: {
                    width: 4
                }
            },
            data: [
                {
                    value: this.AssessList[2].value,
                    name: '高度危险',
                    symbolSize: 5,
                    lineStyle: {
                        type: 'dashed'
                    },
                    areaStyle: {
                        opacity: 0.3,
                        color: 'red'
                    }
                },
                {
                    value:  this.AssessList[1].value,
                    name: '较大危险',
                    symbolSize: 5,
                    lineStyle: {
                        type: 'dashed'
                    },
                    areaStyle: {
                        opacity: 0.3,
                        color: 'yellow'
                    }
                },
                 {
                    value:  this.AssessList[0].value,
                    name: '一般危险',
                    symbolSize: 5,
                    lineStyle: {
                        type: 'dashed'
                    },
                    areaStyle: {
                        opacity: 0.3,
                        color: 'blue'
                    }
                }
            ]
        },
        ]
      }
      },
    //init
      getNext() {
        let _that = this
				_that.$nextTick(() => {
          _that.myChart = echarts.init(_that.$refs.radarChartContainer)
					_that.myChart.setOption(_that.option ,true)
					_that.myChart.resize()
					_that.myChart.on('click', function(params) {
                   _that.$emit('echartsClick', params)
                });
			})
      },
  },
}
</script>

<style>

</style>